export const PROP_TYPES = {
  BOOLEAN: 'boolean',
  NUMBER: 'number',
  STRING: 'string',
  ARRAY: 'array',
  OBJECT: 'object',
  NODE: 'node',
  FILE: 'file',
  ERROR: 'error',
  ANY: 'any',
  FUNCTION: 'function'
}

const isClientSide = typeof window !== 'undefined'

const TYPE_BY_PROP_TYPE = {
  [PROP_TYPES.ANY]: [],
  [PROP_TYPES.BOOLEAN]: [Boolean],
  [PROP_TYPES.NUMBER]: [Number],
  [PROP_TYPES.STRING]: [String],
  [PROP_TYPES.ARRAY]: [Array],
  [PROP_TYPES.OBJECT]: [Object],
  [PROP_TYPES.NODE]: [isClientSide ? Node : Object],
  [PROP_TYPES.FILE]: [...(isClientSide ? [File, Blob] : [])],
  [PROP_TYPES.ERROR]: [Error],
  [PROP_TYPES.FUNCTION]: [Function]
}

export function propValidator(
  propTypes,
  required = true,
  defaultValue,
  validationFunc = () => true
) {
  const propSettings = {
    validator: validationFunc,
    required,
    ...(defaultValue !== undefined ? { default: defaultValue } : {})
  }

  if (propTypes.includes(PROP_TYPES.ANY)) {
    return propSettings
  }

  const types = [
    ...propTypes
      .map(propType => TYPE_BY_PROP_TYPE[propType])
      .filter(v => !!v)
      .reduce((acc, types) => {
        types.forEach(type => {
          acc.add(type)
        })
        return acc
      }, new Set())
  ]

  propSettings.type = types
  return propSettings
}
/* eslint-enable */
